import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type {
  PaginatedResponse,
  BuildingOptionsResponse,
  ReportDataResponse,
} from "../client/types/common.types";
import type {
  GetSwimmersRequest,
  Swimmer,
  SwimmerBatchCreate,
  SwimmerBatchResponse,
  GetSwimmersCountRequest,
  GetSwimmersCountResponse,
  GetSwimmerReportPreviewRequest,
  SwimmerReportDataItem,
  GetBuildingsWithSwimmersRequest,
  GetSwimmersReportDataRequest,
  UpdateSwimmerRequest,
} from "../client/types/swimmer.types";

const createSwimmerEndpoints = (client: HttpClient = getApi()) => ({
  getSwimmers: async (
    params?: GetSwimmersRequest
  ): Promise<PaginatedResponse<Swimmer>> => {
    const { data: response } = await client.get<PaginatedResponse<Swimmer>>(
      "/swimmers",
      { params }
    );
    return response;
  },
  getSwimmersReportPreview: async (
    params?: GetSwimmerReportPreviewRequest
  ): Promise<PaginatedResponse<SwimmerReportDataItem>> => {
    const { data: response } = await client.get<PaginatedResponse<SwimmerReportDataItem>>(
      "/swimmers/report-preview",
      { params }
    );
    return response;
  },
  getSwimmerById: async (swimmer_id: string): Promise<Swimmer> => {
    const { data: response } = await client.get<Swimmer>(
      `/swimmers/${swimmer_id}`
    );
    return response;
  },
  updateSwimmer: async (
    swimmer_id: string,
    data: UpdateSwimmerRequest
  ): Promise<Swimmer> => {
    const { data: response } = await client.patch<Swimmer>(
      `/swimmers/${swimmer_id}`,
      data
    );
    return response;
  },
  createSwimmersBatch: async (
    data: SwimmerBatchCreate
  ): Promise<SwimmerBatchResponse> => {
    const { data: response } = await client.post<SwimmerBatchResponse>(
      "/swimmers/batch",
      data
    );
    return response;
  },
  getSwimmersCount: async (
    params?: GetSwimmersCountRequest
  ): Promise<GetSwimmersCountResponse> => {
    const { data: response } = await client.get<GetSwimmersCountResponse>(
      "/swimmers/count/total",
      { params }
    );
    return response;
  },
  getBuildingsWithSwimmers: async (
    params: GetBuildingsWithSwimmersRequest
  ): Promise<BuildingOptionsResponse> => {
    const { data: response } = await client.get<BuildingOptionsResponse>(
      "/swimmers/buildings-with-swimmers",
      { params }
    );
    return response;
  },
  getSwimmersReportData: async (
    params: GetSwimmersReportDataRequest
  ): Promise<ReportDataResponse<SwimmerReportDataItem>> => {
    const { data: response } = await client.get<
      ReportDataResponse<SwimmerReportDataItem>
    >("/swimmers/report-data", { params });
    return response;
  },
  deleteSwimmer: async (swimmer_id: string): Promise<void> => {
    await client.delete(`/swimmers/${swimmer_id}`);
  },
});

export type SwimmerEndpoints = ReturnType<typeof createSwimmerEndpoints>;

export const swimmerEndpoints = createSwimmerEndpoints();
